module.exports = __webpack_public_path__ + "img/gtm.e2c7ce9.png";